import React, {useState,useEffect,useContext,lazy,Suspense} from "react";
import { useTranslate } from 'react-redux-multilingual'
import { Loading,CardPerso,ColumDataTableReorganize,articleColumnGenerate,customFieldsColumnGenerate,priceSuppColumnGenerate,enumereColumnGenerate,articleEditionDatatable,articleDataGenerator,ProfilActionButton,TagArticleBtn,GenerateBarCodeBtnA4,ProfilParentRestockButton,useLocalStorage,articlePriceUnitSuppDataGenerator} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { useParams } from "react-router-dom";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { IsAuthContext } from '../../../app/App';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { useCookies} from 'react-cookie';
import {articleListErp} from 'app/columnsArticleListeDataTable'
import { Modal } from "react-bootstrap";
import cellEditFactory from 'react-bootstrap-table2-editor';

const CarouselImage = lazy(() => import('../carousel/CarouselImage'));

// Récupération customfields
const useLoadCustomFields = () => {
    const [loadingCustomFields,setLoadingCustomFields]=useState(true)
    const [errorCustomFields,setErrorCustomFields]=useState(false)
    const [customFields,setCustomFields]=useState(false)

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
            ).then((response) => {
                setLoadingCustomFields(false)
                setCustomFields(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                setLoadingCustomFields(false)
                if(error.response==undefined){
                    setErrorCustomFields('unknowError')
                }
                else if(error.response.status==403){
                    setErrorCustomFields('forbiddenGeneral')
                }
                else {
                    setErrorCustomFields('unknowError')
                }
                
            })
        })()
    }, [])

    return [loadingCustomFields,errorCustomFields,customFields]
}

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            // remote
            pagination={ paginationFactory(props.paginationOptions) }
            onTableChange={ props.handleTableChange }
            noDataIndication={props.load.allArticle ? <div className="spinner-border spinner-border-sm"></div> : t('tableNoData')}
            defaultSorted={props.defaultSorted}
            cellEdit={ cellEditFactory({ 
                mode: 'dbclick', 
                blurToSave: true,
            }) }
            hover
            condensed
            responsive
        />
    );
};

const SearchHistoriqueArticle = (props) => {
    const t =useTranslate()
    
    const { posid } = useParams();
    const { authParam } = useContext(IsAuthContext)
    const [cookies, setCookie] = useCookies(['search_histo_article_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['search_histo_article_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.search_histo_article_reorganize && cookies.search_histo_article_reorganize){
            setLocalStorage('search_histo_article_reorganize',cookies.search_histo_article_reorganize);
        }
    }, []);
    
    const [sizeDatas,setSizeDatas]=useState(0)
    const [optionsDataTable,setOptionsDataTable]=useState({
        devise:[],
        marque:[],
        fournisseur:[],
        firstlevelcat:[],
        secondlevelcat:[],
        thirdlevelcat:[],
        fourthlevelcat:[],
        fifthlevelcat:[]

    })
    const [ourOptionsDataTable,setOurOptionsDataTable]=useState({
        devise:{},
        marque:{},
        fournisseur:{},
        firstlevelcat:{},
        secondlevelcat:{},
        thirdlevelcat:{},
        fourthlevelcat:{},
        fifthlevelcat:{}

    })
    const [perPage,setPerPage] = useState(50)
    const [currentPage,setCurrentPage] = useState(1)

    let { SearchBar } = Search;

    // Column de base du datatable (par defaut)
    let cookieLecture = ['date','bar','internalid','name','reference','price','action'];
    if(localStorage.search_histo_article_reorganize){
        let columnShowVar = localStorage.search_histo_article_reorganize;
        cookieLecture = columnShowVar.split(',')
    }
    const [columnShow,setColumnShow] = useState(cookieLecture) 
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    
    // Articles et chargement
    const [allArticles,setAllArticles]=useState([])
    const [load,setLoad]=useState({
        allArticle:false,
    })
    const maxConditionnement = (authParam.company.advanceparams.max_conditionnement!='' && authParam.company.advanceparams.max_conditionnement!=null) ? +authParam.company.advanceparams.max_conditionnement : 0
    const suppPrice = authParam.company.advanceparams.hasOwnProperty('prix_supplementaire') ? authParam.company.advanceparams.prix_supplementaire : []
    const [loadingCustomFields,errorCustomFields,customFields] = useLoadCustomFields();
    
    //Pour le carousel (image)
    const [showCarousel,setShowCarousel]=useState(false) 
    const [modalItemName,setModalItemName]=useState('') 
    const [modalImage,setModalImage]=useState('') 

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    // Date expiration cookie
    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    // let thisShop = authParam.sections.find(shop=>shop.id == posid)
    const modulePos = authParam.modules.find(value=>value.name=='pos')    

    // Ouverture carousel image
    const openModalCarousel = (image,itemName) =>{
        setModalImage(image)
        setModalItemName(itemName)
        setShowCarousel(true)
    }

    // Fermeture carousel image
    const closeModalCarousel = () =>{
        setModalImage('')
        setModalItemName('')
        setShowCarousel(false)
    }

    // Recuperation articles
    const loadArticles = async (clientId) =>{
        setLoad({...load,allArticle:true})
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/client/get_last_buy_b2c/"+clientId 
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }
            else{   
                setAllArticles(response.data.datas)
                setLoad({...load,allArticle:false})
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
        setLoad({...load,allArticle:false})
    }

    // Gestion du per page
    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    // Gestion pagination
    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: sizeDatas
    };

    // Tri par defaut
    let defaultSorted = [
        {
          dataField: "date",
          order: "desc"
        }
    ];
    
    // Formatage données
    let dataTable = new Array
    allArticles.forEach((value,ind)=>{
        let obj = {
            masque:'',
            id: value.id,
            devise:(value.devise_achat!=null) ? value.devise_achat : '',//digit={(value.devise_achat!='XPF') ? 2 : 0}
            action:
                <span className="d-flex justify-content-between">
                    <ProfilActionButton  path={'/pos/'+posid+'/item-base/details/'+value.id}/>
                    <ProfilParentRestockButton optionModule={modulePos} value={value} path={'/pos/'+posid+'/automatic-restock/parent-item/'+value.id}/>
                    <TagArticleBtn articleName={value.name} articlePrice={value.price} articleUpc={value.reference} article={value} from='pos'/>
                    {(value.reference!='' && value.reference!=null) && <GenerateBarCodeBtnA4 articles={[value]} devise={props.devise} icon='true'/>}
                </span>,
            index: ind + 1,
            date:value.date_validation,
            bar:value.bar
        }
        articleDataGenerator(obj,value,t,openModalCarousel)
        articlePriceUnitSuppDataGenerator(obj,value,suppPrice)
        if (customFields) {
            customFields.forEach((item,index)=>{
                if(value.custom_fields){
                    obj[item.name]=value.custom_fields[item.name]
                }
            })
        }

        for (let i=0; i<maxConditionnement; i++){
            let numeroEnumere = i+1
            obj['name_'+numeroEnumere]= (value.hasOwnProperty('name_'+numeroEnumere) && value['name_'+numeroEnumere]!=null) ? value['name_'+numeroEnumere] : ''
            obj['reference_'+numeroEnumere]= (value.hasOwnProperty('reference_'+numeroEnumere) && value['reference_'+numeroEnumere]!=null) ? value['reference_'+numeroEnumere] : ''
            obj['quantity_'+numeroEnumere]= (value.hasOwnProperty('quantity_'+numeroEnumere) && value['quantity_'+numeroEnumere]!=null) ? value['quantity_'+numeroEnumere] : ''
        }

        suppPrice.map((item,index)=>{
            let numero = index+1
            let margePrixSupp = (value.hasOwnProperty('margeN_'+item['designation_'+numero]) && value['margeN_'+item['designation_'+numero]]!=null && value['margeN_'+item['designation_'+numero]]!=0) ? value['margeN_'+item['designation_'+numero]] : 0

            let margePercentPrixSupp = (value.hasOwnProperty('margeP_'+item['designation_'+numero]) && value['margeP_'+item['designation_'+numero]]!=null && value['margeP_'+item['designation_'+numero]]!=0) ? value['margeP_'+item['designation_'+numero]] : 0


            obj['price_'+item['designation_'+numero]]= (value.hasOwnProperty('price_'+item['designation_'+numero]) && value['price_'+item['designation_'+numero]]!==null && value['price_'+item['designation_'+numero]]!=='') ? value['price_'+item['designation_'+numero]] : ''

            obj['price_'+item['designation_'+numero]+'_ttc']= (value.hasOwnProperty('price_'+item['designation_'+numero]+'_ttc') && value['price_'+item['designation_'+numero]+'_ttc']!==null && value['price_'+item['designation_'+numero]+'_ttc']!=='') ? value['price_'+item['designation_'+numero]+'_ttc'] : ''

            obj['margeN_'+item['designation_'+numero]]= margePrixSupp

            obj['margeP_'+item['designation_'+numero]]= margePercentPrixSupp
        })
        
        dataTable.push(obj)
    })

    // Recuperation columns datatable
    let columnsInit =[
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "date",
            text: t('ticketDate'),
            editable: false,
            hidden: (columnShow.includes("date")) ? false : true,
            sort: true,
            headerSortingStyle,
        },
        {
            dataField: "bar",
            text: t('referencePo'),
            editable: false,
            hidden: (columnShow.includes("bar")) ? false : true,
            sort: true,
            headerSortingStyle,
        },
        {
            dataField: "internalid",
            text: t('internalId'),
            editable: false,
            hidden: (columnShow.includes("internalid")) ? false : true,
            sort: true,
            headerSortingStyle,
        },
    ];
    let columns = new Array
    if (customFields) {
        columns=[
            ...columnsInit,
            ...articleColumnGenerate(articleListErp,columnShow,headerSortingStyle,articleEditionDatatable,optionsDataTable,ourOptionsDataTable,t,authParam),
            ...enumereColumnGenerate(maxConditionnement,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
            ...priceSuppColumnGenerate(suppPrice,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
            ...customFieldsColumnGenerate(customFields,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ]
    }

    // Chargement de l'organisation des columns depuis cookie si présent
    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.search_histo_article_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.search_histo_article_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("search_histo_article_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [customFields])

    // Quand le client change on charge les articles
    useEffect(function () {
        if (props.clientId !== false) loadArticles(props.clientId);
    }, [props.clientId])

    // Pour gérer l'affichage ou l'organisation des columns
    const handleToggleColumns = (column,indexToEdit) => {
        if(column.toggle){
            var newColumnShow = columnShow.filter(value=>value!=column.dataField)

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = true

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        else{
            var newColumnShow = [...columnShow,column.dataField]

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = false

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        setLocalStorage("article_pos",newColumnShow.join(),{ path: "/", expires: expire_date }) 
    }

    // Quand changement sur tableau
    const handleTableChange = async (type, { page, sizePerPage }) => {
        setPerPage(sizePerPage)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/client/get_last_buy_b2c/"+props.clientId,
        ).then((response) => {
            setAllArticles(response.data.datas)
            setCurrentPage(page)
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    return(<>
        <Modal show={showCarousel} onHide={()=>closeModalCarousel()}>
            <Modal.Header closeButton>
                <Modal.Title>{modalItemName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {showCarousel ?
                    <Suspense fallback={<Loading></Loading>}>
                        <CarouselImage images={modalImage} />
                    </Suspense>
                :
                    false
                }
            </Modal.Body>
        </Modal>
        <CardPerso saClass='position-relative'>
            {(load.allArticle || loadingCustomFields) ? 
                <div className="d-flex justify-content-center"><span className="spinner-border spinner-border-sm"></span></div> 
            :
                (columnOrganize.length!=0) &&
                    <small>
                        <ToolkitProvider
                            keyField="index"
                            data={dataTable}
                            columns={ columnOrganize }
                            search
                            columnToggle
                        >
                            {(propst) => (
                                <>
                                    <div className="d-flex justify-content-between">
                                        <div className="mb-2">
                                            <ColumDataTableReorganize 
                                                columnOrganize={columnOrganize}
                                                setColumnOrganize={setColumnOrganize}
                                                setCookie={setLocalStorage}
                                                cookieName='search_histo_article_reorganize'
                                                { ...propst.columnToggleProps }
                                                executWhenToggle={handleToggleColumns}
                                                showColumnOrganize={showColumnOrganize}
                                                setShowColumnOrganize={setShowColumnOrganize}
                                                btnSwitch={true}//pour affiche ou non le btn swith
                                                initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end align-items-center">
                                            <span className="mb-2 me-1">{t('tableSearch')}:</span>
                                            <SearchBar {...propst.searchProps} className="mb-2" />
                                        </div>
                                    </div>
                                    <div className="position-relative">
                                        <CustomDataTable 
                                            propst={propst}
                                            paginationOptions={paginationOptions}
                                            handleTableChange={handleTableChange}
                                            columns={columnShow}
                                            defaultSorted={defaultSorted}
                                            load={load}
                                        />
                                    </div>
                                </>
                            )}
                        </ToolkitProvider>
                    </small>
            }
        </CardPerso>
        </>
    )
    
}

export default SearchHistoriqueArticle;